<template>
    <div>
        <div class="login-header">
            <button
                v-if="office_btn == 'business'"
                class="btn-default js-bt-selection-opening"
                @click="toggleOfficeButton()"
            >
                {{view.translations.label_button_office_ba_v5}}
            </button>
            <button
                v-else-if="office_btn == 'normal'"
                class="btn-default js-bt-selection-opening"
                @click="toggleOfficeButton()"
            >
                {{view.translations.label_button_office_bb_v5}}
            </button>
        </div>
        <div class="paper form login-card">
            <div>
                <img src="/internacional/public/office5/img/general-png/favicon.png">
            </div>
            <h3>
                {{view.translations.label_login_title_v5}}
            </h3>
            <h5>
                {{view.translations.label_login_subtitle_v5}}
            </h5>

            <form
                method="post"
                id="formLogin"
                ref="formLogin"
                :action="formLoginAction"
                @submit="loginSubmit"
            >
                <input
                    type="hidden"
                    name="login_type"
                    id="login_type"
                    :value="input_login_type"
                >
                    <!-- v-model="input_login_type" -->
                <input
                    type="hidden"
                    name="token"
                    id="token"
                    :value="input_token"
                >
                    <!-- v-model="input_token" -->
                <div :class="['text-left', input_email == '' ? '' : ($v.input_email.$invalid ? 'has-error' : 'has-success') ]">
                    <label for="email" class="form-label">
                        {{view.translations.email}} *
                    </label>
                    <input
                        type="email"
                        name="email"
                        class="email"
                        id="email"
                        :placeholder="view.translations.email"
                        required
                        v-model="input_email"
                        @change="onChange('input_email_v', input_email)"
                    >
                </div>
                <div :class="['text-left',  input_password == '' ? '' : ($v.input_password.$invalid ? 'has-error' : 'has-success') ]">
                    <label for="senha" class="form-label" id="labelSenha">
                        {{labelSenha}} *
                    </label>
                    <input
                        type="password"
                        name="senha"
                        class="senha"
                        id="senha"
                        :placeholder="labelSenha"
                        required
                        v-model="input_password"
                        @change="onChange('input_password_v', input_password)"
                    >
                </div>
                <div class="text-right va-forgot-password">
                    <div class="checkbox">
                        <input
                            type="checkbox"
                            name="virtual_assistant"
                            id="virtual_assistant"
                            v-show="false"
                            v-model="checkbox_va"
                            :value="checkbox_va ? 1 : 0"
                        >
                        <label for="virtual_assistant">{{view.translations.label_are_you_virtual_assistant}}</label>
                    </div>
                    <div class="separator"></div>
                    <div class="forgot-password">
                        {{view.translations.label_lembrar_senha_v5}}
                        <a
                            class=""
                            :href="view.routes['forgot-password']"
                        >
                            {{view.translations.label_password_v5}}
                        </a>
                    </div>
                </div>
                <div>
                    <button
                        id="submit-btn"
                        name="submit_btn"
                        class="btn-success display-block"
                        :disabled="$v.input_email.$invalid || $v.input_password.$invalid"
                    >
                        {{view.translations.button_login}}
                    </button>
                </div>
                <div class="separator">
                    <hr/><span>
                        {{view.translations.label_or_v5}}
                    </span><hr/>
                </div>
            </form>
            <div class="social-buttons">
                <div
                    id="gmail"
                    :class="['social-button-login google', disableGoogleBtn ? 'disabled' : '']"
                    @click.stop="onClickGoogleBtn"
                >
<!--                <div-->
<!--                    id="gmail"-->
<!--                    class="social-button-login google disabled"-->
<!--                    @click.stop="showAlert()"-->
<!--                >-->
                    <div class="social-button-icon">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                    </div>
                    <span class="social-button-text">
                        {{view.translations.label_login_with_v5}}
                        <b>
                            {{view.translations.label_google_v5}}
                        </b>
                    </span>
                    <spring-spinner
                        v-show="loadingGoogleApi"
                        :animation-duration="2000"
                        :size="25"
                        color="#0080fc"
                    />
                </div>
                <div
                    :class="['social-button-login facebook', disableFacebookBtn ? 'disabled' : '']"
                    id="facebook"
                    @click="fb_login"
                >
                    <div class="social-button-icon">
                        <span class="fa fa-facebook"></span>
                    </div>
                    <span class="social-button-text">
                        {{view.translations.label_login_with_v5}}
                        <b>
                            {{view.translations.label_facebook_v5}}
                        </b>
                    </span>
                    <spring-spinner
                        v-show="loadingFacebookApi"
                        :animation-duration="2000"
                        :size="25"
                        color="#fff"
                    />
                </div>
            </div>
        </div>
        <div class="login-footer">
            <div  class="dont-have-account">
                {{view.translations.label_dont_have_an_v5}} <a
                    class=""
                    :href="custom_register_route"
                >
                    {{view.translations.label_account_v5}}
                </a>
            </div>
            <div class="all-rights-reserved" >
                {{view.translations.label_all_rights_reserved_v5}}
                <b>
                    {{view.translations.label_ebusiness4us_v5}}
                </b>
            </div>
        </div>
     </div>
</template>

<script>
    import { SpringSpinner } from 'epic-spinners'
    const { required, email } = require('vuelidate/lib/validators')
    export default {
        name: 'lv5-form',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        validations: {
            input_email: {
                required,
                email
            },
            input_email_v: {
                required,
                email
            },
            input_password: {
                required
            },
            input_password_v: {
                required
            }
        },
        data: function(){
            return {
                loadingGoogleApi: false,
                disableGoogleBtn: false,

                loadingFacebookApi: false,
                disableFacebookBtn: true,

                office_btn: '',

                input_login_type: '',
                input_token: '',
                input_email: '',
                input_email_v: '',
                input_password: '',
                input_password_v: '',
                checkbox_va: false,

                googleAPIs: 0,
                google_routes: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/plus.me',
                custom_register_route: "",
            }
        },
        methods: {
            fbAsyncInit(){
                let vm = this
                FB.init({
                    appId: vm.view.constList.facebook_app_id,
                    cookie: true, // enable cookies to allow the server to access
                    // the session
                    xfbml: true, // parse social plugins on this page
                    version: 'v3.2', // The Graph API version to use for the call
                    oauth: true,
                    status: true,
                });
            },
            showAlert(){
                this.$toast.error(this.view.translations.unavailable_service_enter_email_password);
            },
            alertMsg(type, msg) {
                var html = '<div class="alert alert-'+type+' alert-fade">'+
                                '<button type="button" class="close" data-dismiss="alert">&times;</button>'+
                                msg+
                            '</div>';
                $('#alert-msg').html(html);
                $('.alert-fade').removeClass("animated fadeOutUp");
                $('.alert-fade').addClass("animated fadeInDown");
                setTimeout(function(){
                    $('.alert-fade').removeClass("animated fadeInDown");
                    $('.alert-fade').addClass("animated fadeOutUp");
                    setTimeout(function(){
                        $('.alert-fade').addClass("hide");
                    }, 500);
                }, 7000);
            },
            fb_login(){
                let vm = this;
                if(!this.disableFacebookBtn){
                    FB.login(function(response) {
                        if (response.status === 'connected') {

                            console.log('Welcome!  Fetching your information.... ');

                            let access_token = response.authResponse.accessToken; //get access token
                            //user_id = response.authResponse.userID; //get FB UID

                            //Set input token
                            vm.input_token = access_token;

                            //Set input tipo_login
                            vm.input_login_type = vm.view.data.login_type.FACEBOOK;

                            //Send form
                            setTimeout(()=>{
                                vm.$refs.formLogin.submit();
                            }, 2000);

                        } else {
                            //user hit cancel button
                            console.log('User cancelled login or did not fully authorize.');
                        }
                    }, {scope: 'public_profile,email'});
                }
            },
            loginSubmit() {
                this.$emit('login-submit');
            },
            removeParam(key, sourceURL) {
                let rtn = sourceURL.split("?")[0];
                let param = '';
                let params_arr = [];
                let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

                if (queryString !== "") {
                    params_arr = queryString.split("&");
                    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                        param = params_arr[i].split("=")[0];
                        if (param === key) {
                            params_arr.splice(i, 1); // remove param
                        }
                    }
                    rtn = rtn + "?" + params_arr.join("&");
                }
                return rtn;
            },
            toggleOfficeButton(){
                console.log('toggle')
                this.office_btn = this.office_btn === 'normal' ? 'business' : 'normal';

                if(this.office_btn == 'normal') {
                    var alteredURL = this.removeParam('redir', window.location.href );
                    window.history.pushState({ path: alteredURL }, '', alteredURL);
                }
                if(this.office_btn == 'business') {
					          var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?app=ba5&redir=%2Fbr%2Foffice%2Ffranchise-system';
					          window.history.pushState({ path: newurl }, '', newurl);
				        }
                this.$emit('toggle-office-button')
            },
            HandleGoogleApiLibrary() { // Called when Google Javascript API Javascript is loaded
                let vm = this
                // Load "client" & "auth2" libraries
                let index = this.googleAPIs
                if (this.googleAPIs < 4) {
                    gapi.load('client:auth2', {
                        callback: function() {
                            // Initialize client library
                            // clientId & scope is provided => automatically initializes auth2 library
                            gapi.client.init({
                                apiKey: 	vm.view.constList.google_api_key,
                                clientId: 	vm.view.constList.google_client_id,
                                scope: vm.google_routes
                            }).then(
                                // On success
                                function(success) {
                                    vm.loadingGoogleApi = false;
                                    vm.disableGoogleBtn = false;
                                },
                                // On error
                                function(error) {
                                    vm.googleAPIs += 1
                                    vm.HandleGoogleApiLibrary()
                                    console.log('Error : Failed to Load Google Library 1');
                                    vm.loadingGoogleApi = false;
                                }
                            );
                        },
                        onerror: function() {
                            console.log('Error : Failed to Load Google Library 1');
                            vm.loadingGoogleApi = false;
                        }
                    });
                }
            },
            onLoadGoogleApi() {
            },
            onReadyStateChangeGoogleApi(googleApiEl) {
                if (googleApiEl.readyState === 'complete') {
                    this.onLoadGoogleApi();
                }
            },
            onClickGoogleBtn(){
                if(!this.disableGoogleBtn) {
                    let vm = this
                    // API call for Google login
                    gapi.auth2.getAuthInstance().signIn()
                        .then(
                            // On success
                            function(success) {
                                let response = success.Zi;

                                //Get token
                                vm.input_token = success.getAuthResponse().id_token;
                                vm.input_login_type = vm.view.data.login_type.GOOGLE;

                                setTimeout(()=>{
                                    vm.$refs.formLogin.submit();
                                }, 2000)
                            },
                            // On error
                            function(error) {
                                console.log('Error : Google Login Failed');
                            })
                }
            },
            initGoogleApi() {
                this.loadingGoogleApi = true;
                let vm = this;
                let googleApiEl = document.createElement('script');

                googleApiEl.setAttribute("type", "text/javascript");
                googleApiEl.setAttribute("async", "async");
                googleApiEl.setAttribute("defer", "defer");
                googleApiEl.setAttribute('src',"https://apis.google.com/js/api.js");
                if (googleApiEl.addEventListener) {
                    googleApiEl.addEventListener('load', function () {
                        vm.onLoadGoogleApi();
                        vm.HandleGoogleApiLibrary();
                    });
                } else { // fallback
                    googleApiEl.onreadystatechange = function () {
                        vm.onReadyStateChangeGoogleApi(googleApiEl);
                        vm.HandleGoogleApiLibrary();
                    };
                }
                document.body.appendChild(googleApiEl);
            },
            onLoadFacebookApi() {
                let vm = this;
                vm.loadingFacebookApi = false;
                vm.disableFacebookBtn = false;
            },
            onReadyStateChangeFacebookApi(facebookEl) {
                if (facebookEl.readyState === 'complete') {
                    this.onLoadFacebookApi();
                }
            },
            initFacebookApi(){
                let vm = this;
                this.loadingFacebookApi = true;

                let facebookEl = document.createElement('script');
                let lang = navigator.language || navigator.userLanguage;

                facebookEl.setAttribute("type", "text/javascript");
                facebookEl.setAttribute("async", "async");
                facebookEl.setAttribute("defer", "defer");
                lang = lang.replace('-','_');
                facebookEl.setAttribute('src', 'https://connect.facebook.net/'+lang+'/all.js');

                if (facebookEl.addEventListener) {
                    facebookEl.addEventListener('load', function () {
                        vm.onLoadFacebookApi();
                    });
                } else { // fallback
                    facebookEl.onreadystatechange = function () {
                        vm.onReadyStateChangeFacebookApi(facebookEl);
                    };
                }

                document.getElementById('fb-root').appendChild(facebookEl);
            },
            onChange(key, value) {
                this[key] = value;
                this.$v[key].$touch();
            },
            setAidHashToCreatePage(){
                this.custom_register_route = this.view.routes['dont-have-account'];
                let hash = location.hash;
                hash =  hash.substring(1);
                hash = hash.split('&');

                for(let i =0; i < hash.length; i++){
                    if(hash[i].indexOf('aid') === 0){
                        this.custom_register_route = this.view.routes['dont-have-account'] + '/#' + hash[i];
                    }
                }
            },
        },
        created() {
            this.office_btn = this.view.data.redirDefined ? 'business' : 'normal'
            this.setAidHashToCreatePage();
        },
        mounted(){
            this.initGoogleApi();

            window.fbAsyncInit = this.fbAsyncInit;
            this.initFacebookApi();

            let vm = this;
            $(window).on('load', function(){
                if(vm.view.data.back_toastr_message !== false){
                    vm.$toast[vm.view.data.back_toastr_message_type](vm.view.data.back_toastr_message.replace(/(<([^>]+)>)/ig," "))
                }
            })
        },
        computed: {
            labelSenha() {
                return this.checkbox_va ? this.view.translations.label_access_key : this.view.translations.Senha;
            },
            formLoginAction() {
                return this.checkbox_va ? this.view.routes['rota-office-login-va'] : '';
            },
        },
        watch: {
            '$v.$invalid': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.clear();
                    }
                },
                deep: true
            },
            '$v.input_email_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.view.translations.email} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
            '$v.input_email_v.email': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_invalid_email_v5) );
                    }
                },
                deep: true
            },
            '$v.input_password_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.labelSenha} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// resources/office/js/components/login-v5/forms/login.vue